enum Tone {
  BRIEF = "brief",
  CASUAL = "casual",
  FORMAL = "formal",
}

export default Tone;
